export const getCircles=(state)=>{     
    return state.circles.circles;
}
export const isFetchingCircle = (state, id) => {
    return (id in state.circles.loading);
};

export const shouldFetchCircleDetails=(state, id)=>{
    if(isFetchingCircle(state, id)){
        return false;
    }
    const circles = getCircles(state);
    if(id in circles){
        return false;
    }else{
        return true;
    } 
}

export const loadingInitialCirclesList=(state)=>{
    return ( 
        isFetchingCircle(state) && (Object.keys(state.circles.circles).length === 0)
    )
}

export const getCircleWithId=(state, id)=>{
    const circles = getCircles(state);    
    return (id in circles)?circles[id]:null;
}

export const isWhiteMondayCircle=(state, id)=>{
    const circle = getCircleWithId(state, id);
    if(circle){
        return circle.labels.includes('whitemonday');
    }
    return null;
}

export const savingCircle=(state)=>{     
    return state.circles.saving;
}